// Word-level difference between a line's original and its new text, for
// "Show changes": the words kept, added and removed, in reading order.

export type DiffPart = { kind: 'same' | 'add' | 'del'; text: string };

const words = (s: string) => s.split(/\s+/).filter(Boolean);
// Compare words without their case and trailing punctuation
const key = (w: string) => w.toLowerCase().replace(/[.,;:!?)("'’]+$/g, '').replace(/^[("'‘]+/, '');

export function diffWords(before: string, after: string): DiffPart[] {
  const a = words(before), b = words(after);
  // Longest common subsequence table, from the end
  const lcs: number[][] = Array.from({ length: a.length + 1 }, () => new Array(b.length + 1).fill(0));
  for (let i = a.length - 1; i >= 0; i--) {
    for (let j = b.length - 1; j >= 0; j--) {
      lcs[i][j] = key(a[i]) === key(b[j]) ? lcs[i + 1][j + 1] + 1 : Math.max(lcs[i + 1][j], lcs[i][j + 1]);
    }
  }
  const out: DiffPart[] = [];
  const push = (kind: DiffPart['kind'], text: string) => {
    const last = out[out.length - 1];
    if (last && last.kind === kind) last.text += ` ${text}`;
    else out.push({ kind, text });
  };
  let i = 0, j = 0;
  while (i < a.length && j < b.length) {
    if (key(a[i]) === key(b[j])) { push('same', b[j]); i++; j++; }
    else if (lcs[i + 1][j] >= lcs[i][j + 1]) { push('del', a[i]); i++; }
    else { push('add', b[j]); j++; }
  }
  while (i < a.length) push('del', a[i++]);
  while (j < b.length) push('add', b[j++]);
  return out;
}
